module.exports = __webpack_public_path__ + "static/media/IMG_1677.381e82fb.jpg";